<div class="sidebar">
  <div class="app-logo scale-up text-center py-4" style="--order: 3" >

    @if (ownerType === ownerTypeEnum.BASATA) {
      <img src="assets/images/basata-logo.png" width="140" height="140" alt="Logo"
        class="move-down --order-5 rounded-3 p-3 cursor-pointer" routerLink="/home">
      }

      @if (ownerType === ownerTypeEnum.TFB) {
        <img src="assets/images/tfb-logo.png" width="140" height="140" alt="Logo"
          class="move-down --order-5 rounded-3 p-3 cursor-pointer" routerLink="/home">
        }

      </div>
    </div>

    <div class="col-12 sidebar-menu-items">
      <mat-nav-list>
        <div class="col-12 px-3">
          <div class="sb-module-name pl-2 faded">{{ moduleName | translate}}</div>
        </div>

        @for (menu of menuItems; track menu; let i = $index) {
          <!-- without children -->
          @if (!menu.children) {
            <ng-container *ngxPermissionsOnly="menu?.permissions">
              <a class="content-item"
                style="{{ '--order:' + i * 0.25 }}"
                mat-list-item
                routerLink="{{ menu.route }}"
                routerLinkActive="active-menu"
                aria-label="Sidebar Menu">
                <span class="m-title text-primary">{{ menu.name }}</span>
              </a>
            </ng-container>
          }
          <!-- with children -->
          @if (menu.children) {
            @if (getChildrenPermission(menu?.children)) {
              <mat-accordion>
                <mat-expansion-panel class="content-item mx-1" style="{{ '--order:' + i * 0.25 }}" [expanded]="isActiveRoute(menu?.children)">
                  <mat-expansion-panel-header class="big-menu-items text-primary">
                    <span class="text text-primary">{{ menu.name }}</span>
                  </mat-expansion-panel-header>
                  @for (menuItem of menu.children; track menuItem) {
                    <a *ngxPermissionsOnly="menuItem?.permissions" [routerLink]="menuItem.route"
                      mat-list-item
                      aria-label="Sidebar Menu"
                      routerLinkActive="active-menu">
                      <span>{{ menuItem.name }}</span>
                    </a>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            }
          }
        }
      </mat-nav-list>
    </div>
